// extracted by mini-css-extract-plugin
module.exports = {"contactId":"entity-id_contactId__1z6Lo","copy":"entity-id_copy__321au","creating":"entity-id_creating__2P3wL","created":"entity-id_created__1v-cP"};